// @core/api/endpoints/userprofile/get_userprofile_admin.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUserprofileAdminResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Get user profile (admin)
 * Retrieves full profile details including private information for administrative purposes. Bypasses privacy settings. Requires platform admin privileges.
 */
export async function GetUserprofileAdmin(
  profile_id: string,
  options?: RequestOptions
): Promise<GetUserprofileAdminResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/admin/:profile_id`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.get<GetUserprofileAdminResponse>(requestPath, { ...requestOptions });
}
